export enum TaskFileCategoryEnum {
  ROTOR_LOCK_EVIDENCE = "ROTOR_LOCK_EVIDENCE",
}
